import { createSelector } from '@reduxjs/toolkit';
import { VARIABLES_TYPES } from '../../../components/types/variables';
import { RootState } from '../../rootReducer';
import { IProjectVariablesInitialState } from '../../slices/projectVariables/projectVariables';

const selectQuestionsVariables = (projectVariables: IProjectVariablesInitialState) => {
  const variablesList = {};
  Object.keys(projectVariables).forEach((itemFrontendId) => {
    const variablesArray = projectVariables[itemFrontendId];
    variablesArray.forEach((variable, variableIndex) => {
      if (variable.type !== VARIABLES_TYPES.ADD) {
        return;
      }
      variablesList[variable.id] = {
        name: variable.variableName,
        variableIndex,
      };
    });
  });
  return variablesList;
};

export default createSelector((state: RootState) => state.projectVariables, selectQuestionsVariables);
